import { useEffect, useRef, useState } from "react";
import { animate } from "framer-motion";
import { useCurrency } from "@/context/CurrencyContext";

// Animated count-up price. amountUSD assumed unless `from` given.
export default function AnimatedPrice({ amount, from = "USD", className = "", prefixOriginal = null }) {
  const { convert, currency, symbol } = useCurrency();
  const target = convert(amount, from, currency);
  const [display, setDisplay] = useState(target);
  const prev = useRef(target);

  useEffect(() => {
    const controls = animate(prev.current, target, {
      duration: 0.6,
      ease: [0.2, 0.8, 0.2, 1],
      onUpdate: (v) => setDisplay(v),
    });
    prev.current = target;
    return () => controls.stop();
    // eslint-disable-next-line
  }, [target, currency]);

  const decimals = display >= 1000 ? 0 : display >= 1 ? 2 : 4;
  const s = symbol(currency);
  return (
    <span className={className}>
      {s}
      {s.length > 1 ? " " : ""}
      {display.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}
    </span>
  );
}
